
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate('/signin');
  };

  return (
    <header className="bg-black/80 backdrop-blur-xl border-b border-white/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
            <div className="text-2xl font-light text-white tracking-tight">
              AI<span className="font-semibold">Exchange</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => navigate('/')}
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium cursor-pointer"
            >
              Browse
            </button>
            <button 
              onClick={() => navigate('/exchange')}
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium cursor-pointer"
            >
              Exchange Network
            </button>
            <button 
              onClick={() => navigate('/submit')}
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium cursor-pointer"
            >
              List Agency
            </button>
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-4">
            <Button variant="ghost" size="sm" onClick={handleSignIn}>Sign In</Button>
            <Button
              variant="primary"
              onClick={() => window.open('https://form.typeform.com/to/p6aQCAhU', '_blank')}
              className="whitespace-nowrap cursor-pointer"
            >
              Get Started
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-400 hover:text-white p-2 cursor-pointer transition-colors duration-200"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-6 border-t border-white/10">
            <div className="flex flex-col space-y-6">
              <button 
                onClick={() => { navigate('/'); setIsMenuOpen(false); }}
                className="text-gray-400 hover:text-white transition-colors duration-200 font-medium cursor-pointer text-left"
              >
                Browse
              </button>
              <button 
                onClick={() => { navigate('/exchange'); setIsMenuOpen(false); }}
                className="text-gray-400 hover:text-white transition-colors duration-200 font-medium cursor-pointer text-left"
              >
                Exchange Network
              </button>
              <button 
                onClick={() => { navigate('/submit'); setIsMenuOpen(false); }}
                className="text-gray-400 hover:text-white transition-colors duration-200 font-medium cursor-pointer text-left"
              >
                List Agency
              </button>
              <div className="flex flex-col space-y-3 pt-6">
                <Button variant="ghost" size="sm" onClick={() => { handleSignIn(); setIsMenuOpen(false); }}>Sign In</Button>
                <Button
                  variant="primary"
                  onClick={() => window.open('https://form.typeform.com/to/p6aQCAhU', '_blank')}
                  className="whitespace-nowrap cursor-pointer"
                >
                  Get Started
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
